export default __webpack_public_path__ + "static/media/bracelet_dark.d3c3b288.png";